import 'css-chunksrc/client/pages/occupancyPage/table/projectsDetail/projectRow/cell/styles.scss';export default {
  "cell": "_cell_1gey4_1",
  "failed": "_failed_1gey4_15",
  "value": "_value_1gey4_19"
};